export function toTitleCase(str) {
    return str.replace(/\w\S*/g, (word) =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    );
}

export function copyEnabledChecker(user) {
    const { account = false, permissions = {} } = user?.copyEnabled ?? {};
    const permissionKey = user?.permission;
    
    //Check permission level toggle only if copy is enabled at account level
    //account level disabled -> copy disabled for all
    //account level enabled & no permission level override -> copy enabled all
    //account level enabled & permission level override -> use override
    if (!account) return false;

    return permissions[permissionKey] ?? account;
}
